import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/kakobuy";

export default function ArticlePage() {
  return (
    <>
      <Navbar />
      <main className="pt-20 pb-16 bg-background-50">
        <article className="w-full max-w-4xl mx-auto px-4 md:px-6">
          <nav className="mb-8" aria-label="Breadcrumb">
            <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <li>
                <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
                  Strona główna
                </Link>
              </li>
              <li className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-[10px]"></i>
              </li>
              <li className="text-foreground-700 font-medium">Przewodnik</li>
            </ol>
          </nav>

          <header className="mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-6">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-guide-line text-xs"></i>
              </span>
              Przewodnik Zakupowy
            </div>

            <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-4">
              Kakobuy Spreadsheet — Kompletny Przewodnik dla Polskich Kupujących (2026)
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
              Dowiedz się, czym jest kakobuy spreadsheet, jak z niego korzystać i dlaczego stał się
              niezbędnym narzędziem dla każdego, kto robi zakupy z chińskich platform w Polsce.
              Poznaj wszystkie kategorie produktów, porównaj agentów zakupowych i odkryj sprawdzone
              strategie oszczędzania.
            </p>

            <div className="flex items-center gap-4 mt-6 pt-6 border-t border-background-200/70">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-accent-600 font-semibold text-sm">R</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">Redakcja kakobuy.one</p>
                  <p className="text-xs text-foreground-500">Ostatnia aktualizacja: 21 czerwca 2026</p>
                </div>
              </div>
            </div>
          </header>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 mb-10 border border-background-200/60">
            <h2 className="text-lg font-heading font-bold text-foreground-900 mb-4">Spis treści</h2>
            <ol className="space-y-2">
              {[
                "Czym jest Kakobuy Spreadsheet?",
                "Jak działa Kakobuy Spreadsheet?",
                "Dlaczego warto korzystać ze Spreadsheeta?",
                "Porównanie agentów zakupowych",
                "Kategorie produktów w Kakobuy",
                "Jak bezpiecznie robić zakupy?",
                "FAQ — Najczęściej zadawane pytania",
                "Podsumowanie",
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="text-primary-500 font-semibold text-sm min-w-[24px]">{i + 1}.</span>
                  <a
                    href={`#section-${i + 1}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <section id="section-1" className="mb-10 scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              1. Czym jest Kakobuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              <strong>Kakobuy spreadsheet</strong> to starannie opracowana lista produktów w formie arkusza
              kalkulacyjnego, stworzona z myślą o polskich użytkownikach platform zakupowych. Jest to
              kompleksowe narzędzie, które gromadzi w jednym miejscu sprawdzone linki do produktów,
              aktualne ceny, opinie użytkowników oraz szczegółowe informacje o dostawcach. Dla wielu
              polskich entuzjastów zakupów online, <strong>kakobuy spreadsheet</strong> stał się
              nieodzownym elementem każdej sesji zakupowej.
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              W przeciwieństwie do przypadkowego przeglądania setek ofert na platformach zakupowych,
              spreadsheet oferuje uporządkowaną i zweryfikowaną przez społeczność listę produktów.
              Każdy wpis w arkuszu zawiera nie tylko link do produktu, ale również informacje o jakości,
              czasie dostawy do Polski oraz ewentualnych problemach zgłaszanych przez innych kupujących.
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              Historia <strong>kakobuy spreadsheet</strong> sięga społeczności zakupowej skupionej wokół
              platformy Kakobuy, która z czasem rozrosła się do międzynarodowej bazy wiedzy. Polski
              rynek szczególnie docenił to narzędzie ze względu na przejrzystość informacji o wysyłce
              do naszego kraju oraz uwzględnienie specyfiki polskich procedur celnych.
            </p>
          </section>

          <section id="section-2" className="mb-10 scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              2. Jak działa Kakobuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              Mechanizm działania <strong>kakobuy spreadsheet</strong> jest zaskakująco prosty, a
              jednocześnie niezwykle skuteczny. Arkusz jest regularnie aktualizowany przez zespół
              doświadczonych użytkowników, którzy testują produkty, weryfikują sprzedawców i
              aktualizują ceny. Każdy produkt w arkuszu przechodzi przez proces weryfikacji, co
              minimalizuje ryzyko zakupu od nieuczciwego sprzedawcy.
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              Struktura arkusza obejmuje kilka kluczowych kolumn: nazwę produktu, link bezpośredni,
              cenę w juanach (CNY) i przybliżoną cenę w złotówkach, ocenę jakości, informacje o
              dostępnych rozmiarach i kolorach, a także uwagi od społeczności. Dzięki temu każdy
              użytkownik może szybko znaleźć to, czego szuka, bez konieczności samodzielnego
              przeszukiwania platformy.
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              <strong>Kakobuy spreadsheet Polska</strong> zawiera dodatkowo informacje specyficzne dla
              polskiego rynku, takie jak szacunkowe koszty wysyłki do Polski, orientacyjny czas
              dostawy oraz uwagi dotyczące odprawy celnej. To czyni go szczególnie wartościowym dla
              polskich kupujących, którzy często napotykają na dodatkowe wyzwania logistyczne.
            </p>
          </section>

          <section id="section-3" className="mb-10 scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              3. Dlaczego warto korzystać z Kakobuy Spreadsheet?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-time-line text-primary-600"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">Oszczędność czasu</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Zamiast spędzać godziny na przeszukiwaniu platform, znajdujesz sprawdzone produkty
                  w jednym miejscu. Kakobuy spreadsheet eliminuje potrzebę ręcznego filtrowania setek ofert.
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-shield-check-line text-accent-600"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">Bezpieczeństwo</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Produkty w arkuszu są weryfikowane przez społeczność. Unikasz oszustw i
                  niskiej jakości towarów, które często trafiają się przypadkowym kupującym.
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-money-dollar-circle-line text-secondary-600"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">Niższe ceny</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Dzięki porównaniu cen od różnych sprzedawców, zawsze znajdziesz najlepszą ofertę.
                  Arkusz pomaga uniknąć przepłacania za te same produkty.
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-global-line text-primary-600"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">Polska specyfika</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Informacje dostosowane do polskiego rynku — cła, podatki, koszty wysyłki. Wszystko,
                  czego potrzebujesz jako polski kupujący.
                </p>
              </div>
            </div>
          </section>

          <section id="section-4" className="mb-10 scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              4. Porównanie agentów zakupowych
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              Wybór odpowiedniego agenta zakupowego ma kluczowe znaczenie dla udanych zakupów.
              Poniższa tabela porównuje najpopularniejsze platformy dostępne dla polskich użytkowników.
            </p>

            <div className="overflow-x-auto rounded-xl border border-background-200/60">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-100">
                    <th className="text-left p-4 font-semibold text-foreground-800">Funkcja</th>
                    <th className="text-left p-4 font-semibold text-primary-600">Kakobuy</th>
                    <th className="text-left p-4 font-semibold text-foreground-800">AllChinaBuy</th>
                    <th className="text-left p-4 font-semibold text-foreground-800">OrientDig</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-background-200/60">
                  <tr>
                    <td className="p-4 text-foreground-700 font-medium">Spreadsheet</td>
                    <td className="p-4 text-primary-600">✅ Dostępny</td>
                    <td className="p-4 text-foreground-600">✅ Dostępny</td>
                    <td className="p-4 text-foreground-600">✅ Dostępny</td>
                  </tr>
                  <tr className="bg-background-50">
                    <td className="p-4 text-foreground-700 font-medium">Wysyłka do Polski</td>
                    <td className="p-4 text-primary-600">✅ Tak</td>
                    <td className="p-4 text-foreground-600">✅ Tak</td>
                    <td className="p-4 text-foreground-600">✅ Tak</td>
                  </tr>
                  <tr>
                    <td className="p-4 text-foreground-700 font-medium">Czas realizacji</td>
                    <td className="p-4 text-primary-600 font-semibold">7-12 dni</td>
                    <td className="p-4 text-foreground-600">8-14 dni</td>
                    <td className="p-4 text-foreground-600">10-15 dni</td>
                  </tr>
                  <tr className="bg-background-50">
                    <td className="p-4 text-foreground-700 font-medium">Obsługa klienta</td>
                    <td className="p-4 text-primary-600">Dobra</td>
                    <td className="p-4 text-foreground-600">Bardzo dobra</td>
                    <td className="p-4 text-foreground-600">Średnia</td>
                  </tr>
                  <tr>
                    <td className="p-4 text-foreground-700 font-medium">Metody płatności</td>
                    <td className="p-4 text-primary-600">PayPal, Karta</td>
                    <td className="p-4 text-foreground-600">PayPal, Karta</td>
                    <td className="p-4 text-foreground-600">Karta</td>
                  </tr>
                  <tr className="bg-background-50">
                    <td className="p-4 text-foreground-700 font-medium">Język polski</td>
                    <td className="p-4 text-primary-600">Częściowo</td>
                    <td className="p-4 text-foreground-600">Nie</td>
                    <td className="p-4 text-foreground-600">Nie</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section id="section-5" className="mb-10 scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              5. Kategorie produktów w Kakobuy Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              <strong>Kakobuy spreadsheet</strong> obejmuje szeroki zakres kategorii produktowych, od
              odzieży po akcesoria. Poniżej znajduje się przegląd najpopularniejszych kategorii:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              {[
                { cat: "Buty (Shoes)", desc: "Sneakersy, buty sportowe, eleganckie — od najpopularniejszych modeli po limitowane edycje." },
                { cat: "Bluzy i Swetry", desc: "Hoodies, bluzy z kapturem, swetry — idealne na każdą porę roku." },
                { cat: "T-Shirty", desc: "Koszulki z nadrukami, basicowe T-shirty, odzież streetwearowa." },
                { cat: "Kurtki", desc: "Kurtki zimowe, wiosenne, bomberki — szeroki wybór fasonów i marek." },
                { cat: "Spodnie i Szorty", desc: "Jeansy, joggersy, spodnie materiałowe — wygoda i styl." },
                { cat: "Akcesoria", desc: "Zegarki, biżuteria, okulary i inne dodatki modowe." },
                { cat: "Torby i Plecaki", desc: "Torby na ramię, plecaki, listonoszki — funkcjonalność i design." },
                { cat: "Perfumy", desc: "Zapachy inspirowane markowymi perfumami w przystępnych cenach." },
              ].map((item) => (
                <div key={item.cat} className="flex items-start gap-3 bg-background-100 rounded-xl p-4 border border-background-200/60">
                  <span className="w-3 h-3 rounded-full bg-primary-400 mt-1.5 flex-shrink-0"></span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">{item.cat}</p>
                    <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              Wszystkie kategorie są regularnie aktualizowane, a nowe produkty dodawane na podstawie
              rekomendacji społeczności. Aby zobaczyć pełną listę produktów w danej kategorii,
              odwiedź{" "}
              <Link to="/" className="text-primary-600 hover:text-primary-700 underline cursor-pointer">
                naszą stronę główną
              </Link>
              {" "}i skorzystaj z menu kategorii lub przejdź bezpośrednio do{" "}
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline cursor-pointer">
                kaspreadsheet.com
              </a>.
            </p>
          </section>

          <section id="section-6" className="mb-10 scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              6. Jak bezpiecznie robić zakupy z Kakobuy?
            </h2>

            <div className="bg-accent-50 border border-accent-200 rounded-xl p-5 md:p-6 mb-6">
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-alert-line text-accent-600 text-lg"></i>
                </span>
                <div>
                  <h3 className="text-base font-semibold text-accent-800 mb-2">Ważne zasady bezpieczeństwa</h3>
                  <p className="text-sm text-accent-700 leading-relaxed">
                    kakobuy.one jest wyłącznie stroną informacyjną. Nie sprzedajemy produktów ani nie
                    przetwarzamy płatności. Zawsze sprawdzaj wiarygodność sprzedawcy przed dokonaniem
                    transakcji i korzystaj z bezpiecznych metod płatności.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              {[
                {
                  title: "Sprawdzaj opinie sprzedawcy",
                  desc: "Przed zakupem zawsze czytaj opinie innych kupujących. Zwracaj uwagę na daty opinii i ich szczegółowość. Unikaj sprzedawców z małą liczbą transakcji.",
                },
                {
                  title: "Korzystaj z bezpiecznych metod płatności",
                  desc: "PayPal oferuje ochronę kupującego, dlatego jest zalecaną metodą płatności. Unikaj przelewów bezpośrednich na nieznane konta bankowe.",
                },
                {
                  title: "Dokładnie czytaj opisy produktów",
                  desc: "Zwracaj uwagę na tabele rozmiarów, materiały i zdjęcia od rzeczywistych kupujących. Nie polegaj wyłącznie na zdjęciach producenta.",
                },
                {
                  title: "Śledź swoją przesyłkę",
                  desc: "Po dokonaniu zakupu regularnie sprawdzaj status przesyłki. Zachowaj wszystkie potwierdzenia i numery śledzenia do czasu otrzymania paczki.",
                },
              ].map((tip, i) => (
                <div key={i} className="flex items-start gap-4 bg-background-100 rounded-xl p-4 border border-background-200/60">
                  <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-primary-600 font-semibold text-sm">{i + 1}</span>
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">{tip.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="section-7" className="mb-10 scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
              7. FAQ — Najczęściej zadawane pytania
            </h2>

            <div className="space-y-4">
              {[
                {
                  q: "Czy Kakobuy Spreadsheet jest darmowy?",
                  a: "Tak, kakobuy spreadsheet jest całkowicie darmowy i dostępny dla wszystkich użytkowników. Nasz przewodnik i lista produktów nie wymagają żadnych opłat ani subskrypcji.",
                },
                {
                  q: "Jak często aktualizowany jest spreadsheet?",
                  a: "Arkusz jest aktualizowany regularnie, zazwyczaj co kilka dni. Zespół społeczności nieustannie weryfikuje linki, ceny i dostępność produktów, aby zapewnić najświeższe informacje.",
                },
                {
                  q: "Czy mogę ufać produktom z Kakobuy?",
                  a: "Produkty w spreadsheet przechodzą weryfikację społeczności, co znacznie zwiększa bezpieczeństwo zakupów. Zawsze jednak zalecamy sprawdzenie opinii sprzedawcy przed dokonaniem transakcji.",
                },
                {
                  q: "Czy Kakobuy wysyła do Polski?",
                  a: "Tak, Kakobuy oferuje wysyłkę do Polski. Czas dostawy wynosi zazwyczaj od 7 do 12 dni roboczych, w zależności od wybranej metody wysyłki i aktualnej sytuacji logistycznej.",
                },
                {
                  q: "Jakie są koszty wysyłki do Polski?",
                  a: "Koszty wysyłki zależą od wagi paczki, wybranej metody dostawy oraz aktualnych stawek przewoźników. Kakobuy spreadsheet zawiera szacunkowe koszty dla poszczególnych produktów.",
                },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-100 rounded-xl border border-background-200/60">
                  <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                    <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 group-open:rotate-180 transition-transform duration-200">
                      <i className="ri-arrow-down-s-line text-foreground-500"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>

          <section id="section-8" className="mb-10 scroll-mt-24">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              8. Podsumowanie
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              <strong>Kakobuy spreadsheet</strong> to bez wątpienia jedno z najbardziej przydatnych
              narzędzi dla polskich entuzjastów zakupów z chińskich platform. Dzięki starannie
              opracowanej liście produktów, regularnym aktualizacjom i wsparciu społeczności,
              każdy użytkownik może zaoszczędzić czas i pieniądze, jednocześnie minimalizując
              ryzyko nieudanych zakupów.
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              Niezależnie od tego, czy jesteś doświadczonym kupującym, czy dopiero zaczynasz swoją
              przygodę z zakupami z Chin — <strong>kakobuy spreadsheet Polska</strong> jest
              narzędziem, które znacząco ułatwi Ci cały proces. Od butów po akcesoria, od
              porównań cen po wskazówki dotyczące wysyłki — wszystko w jednym miejscu.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 p-6 bg-primary-50 rounded-2xl border border-primary-200">
              <div className="text-center sm:text-left">
                <p className="text-base font-semibold text-primary-800 mb-1">
                  Gotowy, aby odkryć najlepsze okazje?
                </p>
                <p className="text-sm text-primary-600">
                  Sprawdź kakobuy spreadsheet już teraz i znajdź produkty idealne dla siebie.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-6 py-2.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  buy it now
                </a>
                <Link
                  to="/"
                  className="px-6 py-2.5 border border-primary-300 text-primary-700 font-medium text-sm rounded-full hover:bg-primary-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Wróć na stronę główną
                </Link>
              </div>
            </div>
          </section>

          <div className="text-center pt-8 border-t border-background-200/70 mt-8">
            <p className="text-xs text-foreground-400 mb-2">Ten artykuł ma charakter wyłącznie informacyjny.</p>
            <p className="text-xs text-foreground-400">
              © 2026 kakobuy.one — Wszelkie prawa zastrzeżone.{" "}
              <Link to="/" className="text-primary-600 hover:text-primary-700 underline cursor-pointer">
                Powrót do strony głównej
              </Link>
            </p>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}